import { Component, OnInit } from "@angular/core";
import { ClickOutsideDirective } from "blu-utilities";
import { distinctUntilChanged } from "rxjs/operators";
import { NavBarComponent } from "src/app/components/nav-bar/nav-bar.component";
import { AppService } from "src/services/app.service";
import { UserMenuComponent } from "../user-menu/user-menu.component";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrl: "./sidebar.component.scss",
  imports: [ClickOutsideDirective, UserMenuComponent, NavBarComponent],
})
export class SidebarComponent implements OnInit {
  isSideBarCollapsed = this.appService.isSideBarCollapsed;
  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.listenForSideBarCollapsed();
  }

  listenForSideBarCollapsed() {
    this.appService
      .getNavBarCollapsedObservable()
      .pipe(distinctUntilChanged())
      .subscribe(() => {
        const resizeEvent = new CustomEvent("resize", {
          detail: { width: window.innerWidth, height: window.innerHeight },
        });

        window.dispatchEvent(resizeEvent);
      });
  }

  setIsSideNavBarVisible(value: boolean) {
    this.appService.setIsSideNavBarVisible(value);
  }

  toggleCollapse() {
    this.appService.toggleSideBar();
  }
}
